import { useEffect, useState } from 'react';
import { Loader2, Search } from 'lucide-react';

import { Button } from '../button';
import { Input } from '../input';

interface SearchInputProps {
	placeholder?: string;
	onSearch: (query: string) => void;
	isLoading: boolean;
	className?: string;
	value?: string;
}

export const SearchBar: React.FC<SearchInputProps> = ({
	placeholder = 'Search...',
	onSearch,
	isLoading,
	className = '',
	value='',
}) => {
	const [searchTerm, setSearchTerm] = useState('');
useEffect(() => {
		setSearchTerm(value || '');
	}, [value]);
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		setSearchTerm(value);
		if (value.trim() === '') {
			onSearch('');
		}
	};

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		onSearch(searchTerm.trim() || '');
	};

	return (
		<>
			<form onSubmit={handleSubmit}>
				<div className={`relative w-[350px] ${className}`}>
					<Input
						type="text"
						value={searchTerm}
						onChange={handleChange}
						placeholder={placeholder}
						className="pr-10"
					/>
					<Button
						type="submit"
						disabled={isLoading || searchTerm.length < 2}
						className="absolute right-1 top-1/2 -translate-y-1/2"
						size="icon"
						variant="ghost"
					>
						{isLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Search />}
					</Button>
				</div>
			</form>
		</>
	);
};
